export default __webpack_public_path__ + "static/media/landingIcon.41cba2c6.svg";